export enum Branding {
    RoomexBrand = 'roomex',
    CorpayLodgingBrand = 'corpaylodging',
  }

  
  
